import React, { Suspense, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Router } from 'react-router-dom'
import history from '../../History'
import FloorWardenAcceptor from '../../components/FloorWarden/AcknowledgeForm'
import GuardianLayout from './Layout'
import Loading from '../../components/Loading'
import Routes from './Routes'
import TenantConfig from '../../components/Admin/TenantConfigurator'
import UserConfig from '../../components/UserConfigurator'
import TermsOfUseAcceptance from '../../components/TermsOfUseAcceptance'
import './styles.css'
import { useShowTenantConfigurator } from '../../components/Admin/Hooks/useShowTenantConfigurator'
import useInit from '../../hooks/useInit'
import { showTermsOfUse, setTermsAccepted } from '../../redux/app/actions'

function Guardian() {
    const { isAcknowledged, population, loading } = useShowTenantConfigurator()
    const showTerms = useSelector((state) => state.app.showTermsOfUse)
    useInit()

    // Handle terms of use
    useEffect(() => {
        const systemConfig = localStorage.getItem('systemConfig');
        const termsEnabled = systemConfig ? JSON.parse(systemConfig).termsOfUse : false;
        const previouslyAccepted = localStorage.getItem('termsAccepted');

        if (termsEnabled && !previouslyAccepted) {
            showTermsOfUse(true)
            setTermsAccepted(false)
        }
    }, []);

    const handleTermsAccept = () => {
        localStorage.setItem('termsAccepted', 'true');
        setTermsAccepted(true);
        showTermsOfUse(false);
    };

    document.title = 'BSS Guardian'

    return (
        <Router history={history}>
            <GuardianLayout>
                <FloorWardenAcceptor />
                <TenantConfig
                    loading={loading}
                    acknowledgement={isAcknowledged}
                    population={population}
                />
                <TermsOfUseAcceptance
                    visible={showTerms}
                    onAccept={handleTermsAccept}
                />
                <UserConfig />
                <Suspense fallback={<Loading />}>
                    <Routes />
                </Suspense>
            </GuardianLayout>
        </Router>
    )
}

export default Guardian